export default "__VITE_ASSET__DQFtPI81__"